var map = {
	"./hellohr/blob.png": "te0U"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "gaGL";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\/blob\.png$
// module id = gaGL
// module chunks = 0